import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

// Submitting Component for the Self-Schedule path
export function SelfScheduleSubmitting() {
    return (
        <div className="row justify-content-center align-items-center">
            <div className="col-12 col-xl-10 submitting">
                <div className="submitting-content">
                    {/* Submitting Icon */}
                    <div
                        className="submitting-icon-wrapper mb-4"
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '2rem',
                        }}
                    >
                        <div
                            style={{
                                width: '80px',
                                height: '80px',
                                background: 'rgb(0, 165, 180)',
                                boxShadow: '0 8px 25px rgba(0, 165, 180, 0.25)',
                                animation: 'pulseGlow 2s ease-in-out infinite',
                            }}
                            className="d-flex justify-content-center align-items-center rounded-circle"
                        >
                            <FontAwesomeIcon
                                icon={faSpinner}
                                style={{
                                    color: 'white',
                                    fontSize: '2.5rem',
                                    animation: 'spin 1s linear infinite',
                                }}
                            />
                        </div>
                    </div>

                    {/* Submitting Title */}
                    <div
                        className="submitting-title mb-3"
                        style={{
                            fontSize: '2rem',
                            fontWeight: '500',
                            color: '#00a5b4',
                            textAlign: 'center',
                        }}
                    >
                        Almost there! We're loading the map for you to confirm and pick a time.
                    </div>
                </div>
            </div>
        </div>
    );
}
